module.exports = __webpack_public_path__ + "pic_bizny_web_01@1x.png?d9fd67576c5f5c65d0c19e24980c54aa";